// extracted by mini-css-extract-plugin
var _1 = "rgb(104.9750996016, 60.8266932271, 185.4233067729)";
var _2 = "#f7f7fa";
export { _1 as "ballColor", _2 as "pinColor" }
